module.exports = __webpack_public_path__ + "img/lk_logo.01e10b20.svg";